$(function() {
  
       
		//----- OPEN
		$('[data-popup-open]').on('click', function(e)  {
          var headHeight= $('#shopify-section-header').height();       
          var scrollTop= $(window).scrollTop(); 
          var marTop= parseInt(scrollTop) + parseInt(headHeight);
          
          if($(window).width() > 768){
            if(scrollTop < 180){
              $('.popup-inner').css('top', '23%');
            }
            else{
             $('.popup-inner').css('top', marTop+'px');
            }   
          }
          
          else{
             $('.popup-inner').css('top', '51%');
          }
          
		  var targeted_popup_class = jQuery(this).attr('data-popup-open');
		  $('[data-popup="' + targeted_popup_class + '"]').fadeIn(350);
		  e.preventDefault();
		});
		//----- CLOSE
		$('[data-popup-close]').on('click', function(e)  {
          
		  var targeted_popup_class = jQuery(this).attr('data-popup-close');
		  $('[data-popup="' + targeted_popup_class + '"]').fadeOut(350);
		  e.preventDefault();
		});
});

 $(window).on('scroll', function() {  
       var headHeight= $('#shopify-section-header').height();       
       var scrollTop= $(window).scrollTop();
       var marTop= parseInt(scrollTop) + parseInt(headHeight);
   
        if($(window).width() > 768){
            if(scrollTop < 180){
              $('.popup-inner').css('top', '23%');
            }
            else{
             $('.popup-inner').css('top', marTop+'px');
            }   
        }
          
        else{
             $('.popup-inner').css('top', '51%');
        }    
   
        
 });

  $(document).on('click','#training input:radio, #philosophical input:radio, #boldoptionvalue input:checkbox, #selectInscription input:radio',function(){
     var selectedVal= $(this).val();
     
    
     var lText= $(this).parent("label").text();
    
     var n = lText.indexOf("-");
     var res = lText.substr(n+1);
    
     //$('input[name="properties[inscription]"][value="' + res + '"]').attr('checked',true);
    
     //alert(res);
     $('#selectedInscription').html(lText);
     
     $(".popup-close").trigger( "click" );
  
  })